import React from 'react';
import { Input as ChakraInput } from '@chakra-ui/react';

const Input = React.forwardRef((props, ref) => {
  return <ChakraInput size="sm" ref={ref} {...props} />;
});

export default Input;
